<template>
      <a-row type="flex" justify="space-around" align="middle" class="login height-100" >
        <a-col :span="24" :sm="16" :md="14" :lg="10" class="center">
          <img class="logo logo-center mb4" src="@/assets/logo.png" />
          <div class="mobile-card mobile-snap-bottom">
            <a-card class="card left-align">
            <a-form layout="vertical">
              <a-form-item label="Email">
                <a-input type="email" v-model="data_email" placeholder="Your email"></a-input>
              </a-form-item>
              <a-form-item label="Password">
                <a-input type="password" v-model="data_password" placeholder="Your password"></a-input>
              </a-form-item>
               <a-form-item class="mb0 left">
                  <small><a href="/forgot-password">Forgot Password?</a></small>
               </a-form-item>
              <a-form-item class="mb0 right">
                <a-button size="large" type="primary" :disabled="!comp_isReady" :loading="data_loading" @click="func_onLogin">Login<a-icon type="right"/></a-button>
              </a-form-item>
            </a-form>
          </a-card>
          </div>
          
        </a-col>
      </a-row>
</template>

<script>
import firebase from 'firebase';

export default {
  name: 'Login',
  data() {
    return {
      data_email: '',
      data_password: '',
      data_loading: false
    }
  },
  computed: {
    comp_isReady() {
      return this.data_email.length >= 4 && this.data_password.length >= 6
    }
  },
  methods: {
    func_onLogin() {
      this.data_loading = true;
      firebase.auth().signInWithEmailAndPassword(this.data_email, this.data_password).then((user) => {
        this.data_loading = false;
        this.$router.push('dashboard');
      }).catch((err) => {
        this.data_loading = false;
        console.log('err!', err)
        this.$message.error('Email or password incorrect. Try again.');
      })
    }
  }
}
</script>
